import request from '@/libs/http/index'

/**
 * @description 生成拖拽图
 */
export function generates() {
  return request.get('common/drapCaptcha/generate')
}

/**
 * @description 验证拖拽验证码
 */
export function drapCaptcha(data) {
  return request.post('common/drapCaptcha/verify',data)
}

